export default __webpack_public_path__ + "assets/right-arrow-6056a44de599f597a98ef93a8f8ce2ae.svg";